import * as CSSVars from './../../styles/utilities/css-vars.scss';

export const mainUpdateCSS = (target) => {
  if (!target || $(target.toString()).length == 0) return;
  const headerHeight = $(target.toString()).height();
  const promobarHeight = $('[data-sale-promobar]');
  const Vars = {
    ...CSSVars
  };
  if (!Vars || !headerHeight) return;
  const totalHeight = promobarHeight.length != 0 ? (promobarHeight.height() + headerHeight) : headerHeight;
  document.documentElement.style.setProperty(
    (Vars['mainHeaderHeight'] || Vars.default['mainHeaderHeight']), `${totalHeight.toString()}px`
  );

  if ($('body').hasClass('c-page--collection')) {
    document.documentElement.style.setProperty(
      (Vars['mainHeaderHeightCollection'] || Vars.default['mainHeaderHeightCollection']), `${totalHeight.toString()}px`
    );
  }
}
mainUpdateCSS('[data-header-container]');